'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  DETECT_AUTH: 'detect-auth',
  USER_INFO: 'user-info',
  EXISTING_USER: 'existing-user',
  EXISTING_ACCOUNTS: 'existing-accounts',
  EXISTING_ACCOUNTS_MINIMAL: 'existing-accounts-minimal',
  CHECK_YOUR_EMAIL: 'check-your-email',
  COMPLETE_VERIFICATION: 'complete-verification',
  VERIFICATION: 'verification',
  COMPANY_DOMAIN: 'company-domain',
  SURVEY: 'survey',
  GETTING_STARTED: 'getting-started'
};
module.exports = exports['default'];